import { gql } from '@apollo/client';
import ErrorResultFragment from "../fragments/ErrorResult";

const LOCK_RESOURCE = gql`
  mutation LockResource($resourceId: ID!) {
    lockResource(resourceId: $resourceId) {
      errorResult {
        ...ErrorResultFields
      }
      status {
        isLocked
      }
      success
    }
  }
  ${ErrorResultFragment}
`;

export default LOCK_RESOURCE;
